module.exports = __webpack_public_path__ + "img/erudio_personalizacao.5364b2b0.svg";